import {NavLink} from 'react-router-dom';
import Box from '../shared/layouts/Box';
import Flex from '../shared/layouts/Flex';

const Link = ({ to, isActive, title, children, subMenu, onClick, Icon, counter }) => {
  isActive = isActive || (location.pathname.includes(to.split('/').shift()) && !to.includes('login'));
  return (
    <NavLink
      to={to}
      onClick={onClick}
      css={({ colors, fontWeights}) => ({
        display: 'block',
        color: isActive ? colors?.primaryContrast : colors?.primaryFont,
        'svg path': { fill: colors?.primaryFont },
        '&.active': {
          fontWeight: subMenu ? null : fontWeights?.bold,
          background: colors?.primaryActive,
          color: colors?.primaryContrast,
          'svg path': { fill: colors?.primaryContrast },
        },
      })}
    >
      <Flex
        pl="l"
        alignItems="center"
        height="56px"
        cursor="pointer"
        css={({ colors }) => ({
            '&:hover': {
              background: colors.primaryActive,
              color: colors?.primaryContrast,

              'svg path': {
                fill: colors?.primaryContrast,
              },
              '.counter': {
                background: colors?.white,
                color: colors?.primaryFont,
              }
            },
          })
        }
      >
        {Icon ? <Icon width="2rem" height="2rem" /> : null}
        {title ? <Box pl="m">{title}</Box> : null}
        {counter ? (
          <Flex
            className="counter"
            css={({ colors }) => ({
              marginLeft: 'auto',
              marginRight: '.5rem',
              borderRadius: '50%',
              background: isActive ? colors?.white : colors?.primaryActive,
              color: isActive ? colors?.primaryFont : colors?.primaryContrast,
            })}
          >
            <div
              css={() => ({
                alignContent: 'center',
                textAlign: 'center',
                minWidth: '1.5rem',
                height: '1.5rem',
                fontSize: '0.8rem'
              })}
            >
              { counter }
            </div>
          </Flex>
        ) : null}
        {children}
      </Flex>
    </NavLink>
  );
};

export default Link;
